'use strict';

var _ = require('lodash');
var MarketLiveDataService = function MarketLiveDataService($q, $log, restangular, liveDataTimeHelperService, configurationService) {
  var marketsNotificationService = restangular.service('domain/marketdemand/changes?noSpinner=true');
  var servicesNotificationService = restangular.service('domain/services/changes?noSpinner=true');
  var lastRefreshTime = {
    'market-demand-analysis': null,
    'market-product-group-analysis': null,
    'service-demand-analysis': null
  };
  function setLastRefreshTime(grid, time) {
    lastRefreshTime[grid] = time;
  }
  function preparePayload(subscription) {
    var payloads = [];
    var marketsPayload = {
      lastEventTimeStamp: liveDataTimeHelperService.getOldestLastRefreshTime(lastRefreshTime),
      marketDemandIds: _.chain(subscription.data).map('marketDemandId').uniq().value()
    };
    payloads.push(marketsNotificationService.post(marketsPayload));
    if (subscription.loadedData['service-demand-analysis']) {
      var loadedServices = subscription.loadedData['service-demand-analysis'];
      var servicesPayload = {
        lastEventTimeStamp: liveDataTimeHelperService.getOldestLastRefreshTime(lastRefreshTime),
        serviceIds: _.chain(loadedServices).map('serviceId').uniq().value()
      };
      payloads.push(servicesNotificationService.post(servicesPayload));
    }
    return payloads;
  }
  function callForNotification(subscription) {
    var payloads = preparePayload(subscription);
    return $q.all(payloads).then(function (data) {
      if (!_.isEmpty(data)) {
        data = mergeMarketAndServiceNotifications(data);
        return liveDataTimeHelperService.transformChangesTimeStamps(data);
      }
    })["catch"](function () {
      $log.warn('Cannot fetch live data for Market and/or Service domains!');
    });
  }
  function mergeMarketAndServiceNotifications(data) {
    if (data && data.length > 1) {
      return {
        layer2Changes: data[0].layer2Changes.concat(data[1].layer2Changes),
        layer3Changes: data[0].layer3Changes.concat(data[1].layer3Changes)
      };
    }
    return data[0];
  }
  function isMatchingGridData(dataToCompare, change, gridId) {
    var keyId = gridId === 'service-demand-analysis' ? 'serviceId' : 'marketDemandId';
    return _.find(dataToCompare, function (entry) {
      return entry[keyId] === change.id;
    });
  }
  function isChangeNewAndMatchGridData(gridId, dataToCompare, change) {
    return isMatchingGridData(dataToCompare, change, gridId) && change.modificationDateTime.isAfter(lastRefreshTime[gridId]);
  }
  function findNotificationForLayerInGrid(gridId, dataToCompare, layerNotification) {
    var changedForGrid = [];
    _.forEach(layerNotification, function (change) {
      if (isChangeNewAndMatchGridData(gridId, dataToCompare, change)) {
        changedForGrid.push(change.id);
      }
    });
    return changedForGrid;
  }
  function prepareNotificationsCount(l2Notifications, l3Notifications) {
    var notificationData = {
      l2Count: null,
      l3Count: l3Notifications.length,
      total: l3Notifications.length
    };
    if (_.isArray(l2Notifications)) {
      notificationData.l2Count = l2Notifications.length;
      notificationData.total += notificationData.l2Count;
    }
    return notificationData;
  }
  function isServiceGridSubscribed(subscription) {
    return subscription.loadedData['service-demand-analysis'];
  }
  function getNotificationDataForMarketGrids(gridId, dataToCompare, notification, subscription) {
    var l2Notifications = isServiceGridSubscribed(subscription) ? notification.layer2Changes : undefined;
    var l3Notifications = findNotificationForLayerInGrid(gridId, dataToCompare, notification.layer3Changes);
    return prepareNotificationsCount(l2Notifications, l3Notifications);
  }
  function extractMarketDemandIdFromServiceId(serviceId) {
    var departureDate = serviceId.match(/\[(.*)]/)[0],
      serviceIdParts = serviceId.split('.'),
      marketIdParts = [configurationService.getHostCarrier(),
      //carrier
      serviceIdParts[0],
      //origin
      departureDate, serviceIdParts[3] //destination
      ];
    return marketIdParts.join('.');
  }
  function getApplicableMarketChanges(gridId, marketsChanges, loadedServices) {
    var loadedServicesIds = _.chain(loadedServices).map('serviceId').uniq().value();
    var associatedMarkets = {};
    _.forEach(loadedServicesIds, function (serviceId) {
      var marketId = extractMarketDemandIdFromServiceId(serviceId);
      associatedMarkets[marketId] = true;
    });
    return _.filter(marketsChanges, function (marketChange) {
      return !!associatedMarkets[marketChange.id] && marketChange.modificationDateTime.isAfter(lastRefreshTime[gridId]);
    });
  }
  function getNotificationDataForServiceGrid(gridId, dataToCompare, notification) {
    var l2Notifications = findNotificationForLayerInGrid(gridId, dataToCompare, notification.layer2Changes);
    var l3Notifications = getApplicableMarketChanges(gridId, notification.layer3Changes, dataToCompare);
    return prepareNotificationsCount(l2Notifications, l3Notifications);
  }
  function prepareNotificationForMarketToolbar(gridId, subscription, loadedData) {
    var notification = subscription.notification;
    if (gridId === 'market-demand-analysis' || gridId === 'market-product-group-analysis') {
      return getNotificationDataForMarketGrids(gridId, loadedData, notification, subscription);
    } else if (gridId === 'service-demand-analysis') {
      return getNotificationDataForServiceGrid(gridId, loadedData, notification);
    }
  }
  return {
    callForNotification: callForNotification,
    setLastRefreshTime: setLastRefreshTime,
    prepareNotificationForMarketToolbar: prepareNotificationForMarketToolbar
  };
};
MarketLiveDataService.$inject = ['$q', '$log', 'Restangular', 'LiveDataTimeHelperService', 'ConfigurationService'];
module.exports = MarketLiveDataService;